import React from 'react';

import fetchInit from '../lib/fetchInit';
import logoImg from './logo-1504.gif';
import siteLogoImg from './logo2.svg';
import styles from './nav.scss';

const logo = () => (
  <a href="https://www.nies.go.jp/" target="_blank" rel="noopener noreferrer">
    <img className={styles.logo} src={logoImg}></img>
  </a>
);

export default function nav(user, logoutUrl, {lang=null, setLang=(() => undefined), topPage=false}={}) {
  const handleClick = (lang) => {
    if (window.history.replaceState) {
      const url = (() => {
        if (lang === 'ja') {
          return `?lang=${lang}`;
        } else {
          return window.location.pathname + window.location.search.replace(/[\?&]lang=[^&]+/, '').replace(/^&/, '?');
        }
      })();

      window.history.replaceState(null, '', url);
    }

    setLang(lang === 'ja' ? lang : null);
  };

  const LangSetter = ({globalLang, lang}) => {
    globalLang = globalLang || 'en';

    const props = {
      className: styles.nolink,
    };
    if (globalLang !== lang) {
      Object.assign(props, {
        className: styles.link,
        onClick: () => handleClick(lang),
      });
    }

    return (
      <span {...props}>{lang}</span>
    );
  };

  const handleLogout = async (e) => {
    e.preventDefault();
    await fetch(logoutUrl, fetchInit());
    window.location.href = window.location.href;
  };

  return (
    <nav className={styles.nav}>
      <div className={styles.navInner}>
        <div className={styles.left}>
          A-PLAT Pro
        </div>
        <div className={styles.right}>
          {topPage && logo()}
          <div className={styles.language}>
            <LangSetter globalLang={lang} lang={'en'} /> / <LangSetter globalLang={lang} lang={'ja'} />
          </div>
          <div className={styles.user}>{user}</div>
          <a className={styles.logout} href="#" onClick={handleLogout}>log out</a>
        </div>
      </div>
    </nav>
  );
}
